module.exports = __webpack_public_path__ + "img/welcome.7f35474b.svg";